export default (props: any) =>
<svg width="100%" height="100%" viewBox="0 0 24 24" version="1.1" {...props}>
    <title>Files</title>
    <g transform="matrix(0.913043,0,0,0.913043,-802.476,-360.313)">
        <path d="M893.993,394.629L884.116,394.629C883.407,394.629 882.831,395.205 882.831,395.915L882.831,419.629C882.831,420.339 883.407,420.915 884.116,420.915L899.974,420.915C900.683,420.915 901.259,420.339 901.259,419.629L901.259,400.878L894.416,400.878C894.183,400.878 893.993,400.689 893.993,400.455L893.993,394.629ZM894.84,400.031L894.84,394.989L900.762,400.031L894.84,400.031Z" />
    </g>
</svg>

